import { render } from "./FaqItem.vue?vue&type=template&id=d245a4f6&scoped=true"
import script from "./FaqItem.vue?vue&type=script&lang=js"
export * from "./FaqItem.vue?vue&type=script&lang=js"

import "./FaqItem.vue?vue&type=style&index=0&id=d245a4f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d245a4f6"]])

export default __exports__